// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.news-pdf__title[data-v-7ac2c2ef] {\n  flex-wrap: nowrap;\n}\n.news-pdf__name[data-v-7ac2c2ef] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.news-pdf__body[data-v-7ac2c2ef] {\n  padding: 12px !important;\n  background: #f1f5f9;\n  -webkit-touch-callout: none;\n}\n", ""]);
// Exports
module.exports = exports;
